import { historyResource, HistoryResource } from '@witkac/kartamiejska-resources';
import { HistoryFilters, HistoryLog, ListResponse } from '@witkac/kartamiejska-shared';

import { AbstractModule } from './abstract.module';

/**
 * Moduł historii
 *
 * @class EntityHistoryModule
 * @extends {AbstractModule<HistoryResource>}
 */
class EntityHistoryModule extends AbstractModule<HistoryResource> {
  /**
   * stan store
   *
   * @memberof EntityHistoryModule
   */
  public state = {
    list: [],
    count: 0
  };

  public mutations = {
    /**
     * Zapisuje listę i liczbę rekordów do stanu
     *
     * @param {*} localState
     * @param {ListResponse<HistoryLog>} history
     */
    saveList(localState: any, history: ListResponse<HistoryLog>) {
      localState.count = history.count;
      localState.list = history.list;
    }
  };

  public actions = {
    /**
     * Pobiera historię
     *
     * @param context context
     * @param filter filtry
     */
    list: async (context: any, filter: HistoryFilters) => {
      const history: ListResponse<HistoryLog> = await this.resource.list(filter);
      context.commit('saveList', history);
    },

    /**
     * Zaawansowana historia
     *
     * @param {*} context
     * @param {HistoryFilters} filter
     */
    advancedList: async (context: any, filter: HistoryFilters) => {
      filter.advanced = true;
      const history: ListResponse<HistoryLog> = await this.resource.list(filter);
      context.commit('saveList', history);
    }
  };

  constructor() {
    super(historyResource);
  }
}

export default new EntityHistoryModule();
